export const maxFileSize = (fileSize) => {
    if(fileSize > 10000000) {
        return false
    }
    return true
}

export default maxFileSize